/*
  gratis-dose-aktion (code GRATISDOSE)

  der shopify-rabatt ist ein "kauf x, erhalte y": eine dose aus der kollektion
  matcha-tee kaufen, eine premium-dose gratis. shopify legt die gratis-dose aber
  nicht selbst in den warenkorb. dieses skript macht das, sobald die kundin die
  aktion in der promo-leiste aktiviert hat (oder im rubbel-popup die gratis-dose
  gewonnen hat):

  - code per /discount/ im cookie merken, damit der checkout ihn einträgt
  - liegt eine bezahlte matcha-dose im warenkorb, kommt genau eine premium-dose
    mit der eigenschaft "Geschenk" dazu
  - fliegt die letzte bezahlte dose raus, fliegt auch das geschenk raus

  konfiguration kommt aus der promo-leiste (window.matchoyaGratisdose).
*/
(function () {
  var cfg = window.matchoyaGratisdose || {};
  var code = cfg.code || 'GRATISDOSE';
  var gift_variant = parseInt(cfg.giftVariant, 10);
  var products = String(cfg.products || '')
    .split(',')
    .map(function (s) { return parseInt(s, 10); })
    .filter(function (n) { return !isNaN(n); });
  var storage_key = 'matchoya_gratisdose';
  var gift_label = 'gratis mit Code ' + code;
  var running = false;

  function is_active() {
    try { return localStorage.getItem(storage_key) === '1'; } catch (e) { return false; }
  }

  function mark_bar() {
    document.documentElement.classList.add('matchoya-gratisdose-active');
    var bar = document.getElementById('HdrAnnouncementBar');
    if (!bar) return;
    bar.classList.add('is-done');
    var done = bar.querySelector('.promo-leiste__done');
    if (done) done.hidden = false;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function render_cart(sections, open_drawer) {
    if (/^\/cart\/?$/.test(location.pathname)) {
      location.reload();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (open_drawer && drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ sections: sections });
      return;
    }
    // ohne geöffneten warenkorb nur die zahl am warenkorb-symbol aktualisieren
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var inner = parsed.querySelector('.shopify-section');
      if (inner) bubble.innerHTML = inner.innerHTML;
    }
  }

  function sync_cart(open_drawer) {
    if (running || !is_active() || !gift_variant) return Promise.resolve();
    running = true;
    var section_params = { sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname };

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gift = null;
        var has_paid_can = false;
        cart.items.forEach(function (item) {
          var props = item.properties || {};
          if (props._gratisdose) {
            gift = item;
          } else if (products.indexOf(item.product_id) !== -1) {
            has_paid_can = true;
          }
        });

        if (has_paid_can && !gift) {
          return post('/cart/add.js', Object.assign({
            items: [{ id: gift_variant, quantity: 1, properties: { _gratisdose: '1', Geschenk: gift_label } }]
          }, section_params));
        }
        if (gift && !has_paid_can) {
          return post('/cart/change.js', Object.assign({ id: gift.key, quantity: 0 }, section_params));
        }
        if (gift && gift.quantity > 1) {
          // der rabatt deckt nur eine dose ab
          return post('/cart/change.js', Object.assign({ id: gift.key, quantity: 1 }, section_params));
        }
        return null;
      })
      .then(function (res) {
        if (res && res.sections) render_cart(res.sections, open_drawer);
      })
      .catch(function () {})
      .then(function () { running = false; });
  }

  function activate() {
    try { localStorage.setItem(storage_key, '1'); } catch (e) {}
    mark_bar();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'gratisdose_claim' });
    // code direkt am warenkorb hinterlegen, dann zeigt schon der warenkorb die dose mit 0 €
    return post('/cart/update.js', { discount: code })
      .catch(function () {
        return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' });
      })
      .catch(function () {})
      .then(function () { return sync_cart(true); });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-gratisdose-claim]');
    if (!btn) return;
    event.preventDefault();
    activate();
  });

  // rubbel-popup: wer die gratis-dose gewinnt, bekommt sie ebenfalls automatisch
  window.dataLayer = window.dataLayer || [];
  var original_push = window.dataLayer.push;
  window.dataLayer.push = function () {
    var result = original_push.apply(window.dataLayer, arguments);
    for (var i = 0; i < arguments.length; i++) {
      var entry = arguments[i];
      if (entry && entry.event === 'popup_signup' && entry.popup_offer === 'free_can') activate();
    }
    return result;
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(function () { sync_cart(true); }, 300);
    });
  }

  if (is_active()) {
    mark_bar();
    sync_cart(false);
  }
})();
